import axios from "axios";
import store from "@/store";
import { isMobile } from "@/utils/device";
import { agentServiceBrowserErrorMessage } from "@/utils/agent-service/browser-error";

// 复用MTS代理/JWT，不触发通用全屏加载或反复Toast；错误由语言栏就地显示。
const client = axios.create({ baseURL: "/dev-api", timeout: 10000 });
const base = "/api/mts-api/agent-service/v1/conversations";
const call = async (url, method = "get", data) => {
  const token = store.getters.token;
  const config = {
    url,
    method,
    data,
    agentServiceLocalizedError: true,
    headers: {
      platform: isMobile() ? "H5" : "PC",
      "Accept-Language": store.state.locale.uiLocale,
      ...(token ? { Authorization: token } : {}),
    },
  };
  let result;
  try {
    result = await client.request(config);
  } catch (error) {
    const message = agentServiceBrowserErrorMessage(error);
    if (message) error.message = message;
    throw error;
  }
  if (result.data?.code !== 200 || !result.data?.data) {
    const message = agentServiceBrowserErrorMessage({
      config,
      response: result,
    });
    throw new Error(message || "多语言接口未返回有效回执。");
  }
  return result.data.data;
};
/** 三个补充接口独立于旧会话契约；仅访问当前登录用户有权查看的会话。 */
export const agentServiceLanguageApi = {
  read: (id) => call(`${base}/${encodeURIComponent(id)}/language`),
  update: (id, body) =>
    call(`${base}/${encodeURIComponent(id)}/language`, "put", body),
  translations: (id, ids) => {
    const query = new URLSearchParams();
    ids.forEach((messageId) => query.append("businessMessageId", messageId));
    return call(`${base}/${encodeURIComponent(id)}/translations?${query}`);
  },
};
